module.exports = __webpack_public_path__ + "static/media/p4.22cf99f1.jpg";